import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-1 pb-10 my-2 flex flex-col sm:flex-row justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-5 sm:mb-0" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "leading-6 mb-2 font-bold tracking-tight text-gray-900 dark:text-gray-100 text-2xl" }, " Random image "),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-1 max-w-2xl text-sm text-gray-500 dark:text-gray-400" }, " Here's a random image from one of the collections. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheRandomImage = _resolveComponent("TheRandomImage")!
  const _component_TheMainContentFrame = _resolveComponent("TheMainContentFrame")!

  return (_openBlock(), _createBlock(_component_TheMainContentFrame, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$refs.image.updateImage && _ctx.$refs.image.updateImage(...args))),
          class: "inline-flex justify-center items-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-twitter text-base font-medium text-white hover:bg-blue-twitter-dark focus:outline-none focus:ring-2 focus:ring-offset-2 dark:ring-offset-gray-800 focus:ring-blue-twitter sm:ml-3 sm:w-auto sm:text-sm"
        }, " Update ")
      ]),
      _createVNode(_component_TheRandomImage, {
        categories: $props.categories,
        ref: "image"
      }, null, 8, ["categories"])
    ]),
    _: 1
  }))
}